import { BadgeCheck } from "lucide-react";

const TRUST_SEAL_CLIP_PATH = "polygon(50% 0%, 55% 4%, 62% 1%, 66% 7%, 74% 5%, 77% 12%, 85% 13%, 86% 21%, 94% 25%, 92% 33%, 100% 38%, 96% 46%, 100% 54%, 96% 62%, 92% 67%, 94% 75%, 86% 79%, 85% 87%, 77% 88%, 74% 95%, 66% 93%, 62% 99%, 55% 96%, 50% 100%, 45% 96%, 38% 99%, 34% 93%, 26% 95%, 23% 88%, 15% 87%, 14% 79%, 6% 75%, 8% 67%, 0% 62%, 4% 54%, 0% 46%, 4% 38%, 8% 33%, 6% 25%, 14% 21%, 15% 13%, 23% 12%, 26% 5%, 34% 7%, 38% 1%, 45% 4%)";

export default function TrustBadge() {
  return (
    <div
      role="img"
      aria-label="Trusted by 1,200 plus youth pastors"
      className="relative flex size-[152px] items-center justify-center text-white shadow-[0_12px_30px_rgba(0,0,0,0.34)] md:size-[168px]"
      style={{
        clipPath: TRUST_SEAL_CLIP_PATH,
        background: "radial-gradient(circle at 32% 24%, #FFE7A0 0%, #D8B13F 36%, #9B6E16 100%)",
      }}
    >
      <div className="absolute inset-[6px] bg-[#d82435]" style={{ clipPath: TRUST_SEAL_CLIP_PATH }} />
      <span className="relative flex size-[116px] flex-col items-center justify-center rounded-full border border-[#F5D97D] p-2 text-center leading-none md:size-[130px]">
        <span className="absolute inset-[5px] rounded-full border border-dashed border-[#F5D97D]/75" />
        <span className="relative flex items-center gap-1 text-[7px] font-extrabold uppercase tracking-[0.13em] text-[#F5D97D] md:text-[8px]">
          <span aria-hidden="true">★</span>
          Trusted by
          <span aria-hidden="true">★</span>
        </span>
        <BadgeCheck className="relative mt-1 size-7 text-[#F5D97D] md:size-8" aria-hidden="true" />
        <span className="relative mt-1 text-[24px] font-black tracking-[-0.05em] text-white md:text-[28px]">1,200+</span>
        <span className="relative mt-0.5 text-[7px] font-extrabold uppercase tracking-[0.13em] text-[#F5D97D] md:text-[8px]">Youth pastors</span>
      </span>
    </div>
  );
}

export function FooterTrustBadge() {
  return <div className="flex justify-center bg-[#1A1A1A] px-6 py-10 font-sans"><TrustBadge /></div>;
}
